import React, { Component } from 'react';
import { TwitterShareButton, VKShareButton, FacebookShareButton, OKShareButton } from 'react-share'
import {
  FacebookIcon,
  TwitterIcon,
  VKIcon,
  OKIcon
} from 'react-share';
import {sendEvent} from "../../helpers/analytics";


class TestShare extends Component {
  render () {
    let styles = {
      fill: 'transparent'
    };

    const size = 20;

    return (
      <div className="test__share">
        <div className="share__title">Поделиться результатом</div>
        <div className="share__buttons">
          <VKShareButton url={window.location.origin + '/result.html'}>
            <span onClick={() => sendEvent('main', 'click', 'share vk')}>
              <VKIcon size={size} iconBgStyle={styles} logoFillColor={"#d6d6d6"}/>
            </span>
          </VKShareButton>
          <FacebookShareButton url={window.location.origin + '/result.html'}>
            <span onClick={() => sendEvent('main', 'click', 'share fb')}>
              <FacebookIcon size={size} iconBgStyle={styles} logoFillColor={"#d6d6d6"}/>
            </span>
          </FacebookShareButton>
          <TwitterShareButton url={window.location.origin + '/result.html'}>
            <span onClick={() => sendEvent('main', 'click', 'share tw')}>
              <TwitterIcon size={size} iconBgStyle={styles} logoFillColor={"#d6d6d6"}/>
            </span>
          </TwitterShareButton>
          <OKShareButton url={window.location.origin + '/result.html'}>
            <span onClick={() => sendEvent('main', 'click', 'share ok')}>
              <OKIcon size={size} iconBgStyle={styles} logoFillColor={"#d6d6d6"}/>
            </span>
          </OKShareButton>
        </div>
      </div>
    )
  }
}

export default TestShare


// WEBPACK FOOTER //
// ./src/pages/test/share.js